module.exports = __webpack_public_path__ + "static/undraw_coding_6mjf-5f53b94aec17e6024e4ff98b00f4cde7.svg";